export const hasNotPaidAnything = ({
  canPayFull,
  canPayDeposit,
  canPayRemaining,
  depositAmount,
}) => canPayFull && !canPayRemaining && (canPayDeposit || depositAmount === 0)

export const hasPaidDepositOnly = ({
  canPayFull,
  canPayDeposit,
  canPayRemaining,
}) => !canPayFull && canPayDeposit && canPayRemaining

export const hasPaidInFull = ({ canPayFull, canPayDeposit, canPayRemaining }) =>
  !canPayFull && !canPayDeposit && !canPayRemaining

export const hasMadeQuestPayment = (questPayments) =>
  !hasNotPaidAnything(questPayments)

/**
 * Skip payment when amount due is $0:
 * - discountedCost === 0 → skip
 * - discountedCost is null/undefined → skip only if actualCost === 0
 * - otherwise require payment
 */
export const shouldSkipQuestPayment = ({ discountedCost, actualCost } = {}) => {
  if (discountedCost !== null && discountedCost !== undefined) {
    return Number(discountedCost) === 0
  }
  return Number(actualCost) === 0
}

export const isQuestPaymentSatisfied = (questPayments = {}) =>
  hasMadeQuestPayment(questPayments) || shouldSkipQuestPayment(questPayments)
